module.exports = __webpack_public_path__ + "img/img_1.62c5eb5d.png";